var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('so-quit-button',{staticClass:"pill",attrs:{"disabled":_vm.disabled},on:{"click":_vm.quit}})}
var staticRenderFns = []

export { render, staticRenderFns }